import { EndgameContent } from "../../models/enums";
import { UniqueBossDropEntry } from "../../models/item-data-models";

export const uniqueBossDropsData: UniqueBossDropEntry[] = [
  {
    boss: "Xesht",
    content: EndgameContent.Breach,
    baseTypes: [
      "Beyond Reach",
      "Choir of the Storm",
      "Controlled Metamorphosis",
      "Hand of Wisdom and Action",
      "Skin of the Loyal",
      "The Pandemonius",
      "Xoph's Blood",
    ],
  },
  {
    boss: "Vessel of Kulemak",
    content: EndgameContent.Abyss,
    baseTypes: [
      "Grip of Kulemak",
      "Undying Hate",
      "The Unborn Lich",
      "Darkness Enthroned",
    ],
  },
  {
    boss: "The King in the Mists",
    content: EndgameContent.Ritual,
    baseTypes: [
      "Beetlebite",
      "From Nothing",
      "Ingenuity",
      "Pragmatism",
      "The Burden of Shadows",
    ],
  },
  {
    boss: "Kosis, The Revelation",
    bossLabel: "Kosis",
    content: EndgameContent.Delirium,
    baseTypes: [
      "Assailum",
      "Collapsing Horizon",
      "Megalomaniac",
      "Melting Maelstrom",
      "Perfidy",
      "Strugglescream",
    ],
  },
  {
    boss: "Olroth, Origin of the Fall",
    bossLabel: "Olroth",
    content: EndgameContent.Expedition,
    baseTypes: [
      "Heroic Tragedy",
      "Keeper of the Arc",
      "Olroth's Resolve",
      "Olrovasara",
      "Svalinn",
    ],
  },
  {
    boss: "Zarokh, the Temporal",
    bossLabel: "Zarokh",
    content: EndgameContent.SekhemasTrial,
    baseTypes: [
      "Against the Darkness",
      "Grand Spectrum",
      "Sandstorm Visage",
      "Sekhema's Resolve",
      "Temporalis",
      "The Burden of Leadership",
      "The Changing Seasons",
      "The Desperate Alliance",
      "The Last Flame",
      "The Peacemaker's Draught",
    ],
  },
  {
    boss: "The Trialmaster",
    content: EndgameContent.ChaosTrial,
    baseTypes: [
      "Glimpse of Chaos",
      "Hateforge",
      "Mahuxotl's Machination",
      "The Adorned",
      "Zerphi's Genesis",
    ],
  },
  {
    boss: "The Arbiter of Ash",
    content: EndgameContent.Monolith,
    baseTypes: [
      "Ab Aeterno",
      "Morior Invictus",
      "Prism of Belief",
      "Sacred Flame",
      "Sine Aequo",
      "Solus Ipse",
    ],
  },
  {
    boss: "Corrupted Nexus",
    content: EndgameContent.CorruptedNexus,
    baseTypes: [
      "The Gnashing Sash",
      "Death Articulated",
      "Bursting Decay",
    ],
  },
  {
    boss: "Possessed Monsters",
    content: EndgameContent.AzmeriSpirit,
    baseTypes: [
      "Rite of Passage",
    ],
  },
  {
    boss: "Random Monsters",
    baseTypes: [
      "Leopold's Applause",
    ],
  },
  {
    boss: "Delirium",
    content: EndgameContent.Delirium,
    baseTypes: [
      "Horror's Flight",
      "The Raven's Flock",
      "Voices",
      "The Auspex",
    ],
  },
  {
    boss: "Expedition",
    content: EndgameContent.Expedition,
    baseTypes: [
      "Twisted Empyrean",
      "Uhtred's Chalice",
    ],
  },
  {
    boss: "Breach",
    content: EndgameContent.Breach,
    baseTypes: [
      "Nightfall",
    ],
  },
  {
    boss: "Ritual Reward",
    content: EndgameContent.Ritual,
    baseTypes: [
      "Liminal Coil",
      "Periphery",
      "Sylvan's Effigy",
    ],
  },
  {
    boss: "Atziri, the Red Queen",
    bossLabel: "Atziri",
    content: EndgameContent.Temple,
    baseTypes: [
      "Flesh Crucible",
      "Drillneck",
      "Atziri's Step",
      "Atziri's Splendour",
      "Atziri's Rule",
      "Atziri's Contempt",
    ],
  },
  {
    boss: "The Arbiter of Divinity",
    content: EndgameContent.Origin,
    baseTypes: [
      "The Ordained",
      "Decree of Acuity",
      "Decree of Flight",
      "Decree of Loyalty",
    ],
  },
  {
    boss: "Recipe",
    content: EndgameContent.Crafting,
    baseTypes: [
      "The Taming",
      "Loreweave",
    ]
  },
];
